import script from "./AddMatchupTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddMatchupTable.vue?vue&type=script&setup=true&lang=ts"

import "./AddMatchupTable.vue?vue&type=style&index=0&id=400292b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-400292b6"]])

export default __exports__